export default __webpack_public_path__ + "static/phone-map-desktop-73c19a06ecb747000fe8b07e4306e593.png";